/**
 * @desc createBatchNo
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.BatchMasterCreateRequestParamDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/create/no`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
